import createIcon from '../../createIcon';

/**
 * @component @name SwitchCamera
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUgxNi44M0wxNSAzSDlMNy4xNyA1SDRDMi45IDUgMiA1LjkgMiA3VjE5QzIgMjAuMSAyLjkgMjEgNCAyMUgyMEMyMS4xIDIxIDIyIDIwLjEgMjIgMTlWN0MyMiA1LjkgMjEuMSA1IDIwIDVaTTE1IDE2LjVWMTRIOVYxNi41TDUuNSAxM0w5IDkuNVYxMkgxNVY5LjVMMTguNSAxM0wxNSAxNi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchCamera = createIcon('SwitchCamera', [
  [
    'path',
    {
      d: 'M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM15 16.5V14H9V16.5L5.5 13L9 9.5V12H15V9.5L18.5 13L15 16.5Z',
      key: 'nfrq37',
    },
  ],
]);

export default SwitchCamera;
